import React from "react";
import { useController } from "react-hook-form";
import { Col, FormGroup, Label, UncontrolledTooltip } from "reactstrap";
import { styled } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const Container = styled(FormGroup)`
  width: 100%;
  align-items: center;
  margin-bottom: 0px !important;
  flex-direction: row;
  padding: 0px 15px;
`;

const StyledLabel = styled(Label)`
  text-align: start;
  font-size: 14px;
  flex: 1;
`;

const ToolTipContainer = styled.span`
  margin-left: 10px;
  opacity: 0.5;
  text-decoration: underline;
`;

interface ColorFieldProps {
  label: string;
  name: string;
  info?: string;
  infoId?: string;
}

export default function ColorField({
  name,
  label,
  info,
  infoId,
}: ColorFieldProps) {
  const {
    field: { value, onChange },
  } = useController({
    name,
  });

  return (
    <Container row>
      <Col xs={10} md={10} lg={10}>
        <StyledLabel for={name}>{label}</StyledLabel>
        {info && (
          <ToolTipContainer id={infoId}>
            <FontAwesomeIcon icon={faInfoCircle} color="grey" />
          </ToolTipContainer>
        )}
      </Col>
      <Col xs={2} md={2} lg={2}>
        <input value={value} type="color" onChange={onChange} />
      </Col>
      {info && infoId && (
        <UncontrolledTooltip placement="right" target={infoId}>
          {info}
        </UncontrolledTooltip>
      )}
    </Container>
  );
}
